import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {RequestApiService} from "../../../../services/domain_code/request-api.service";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {Subject} from "rxjs/internal/Subject";

@Component({
    selector: 'logzy-requirement-containers',
    templateUrl: './requirement-containers.component.html',
    styleUrls: ['./requirement-containers.component.scss']
})
export class RequirementContainersComponent implements OnInit {
    constructor(public requestService: RequestApiService
    ) {
    }

    @Input() containersList = new Subject();
    containersColumns = ['container', 'chargable_days', 'total_amount'];

    pageLength = 0;
    dropped: boolean = false;
    screenHeight: number;
    screenWidth: number;
    shadowX!: number;
    shadowY!: number;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('title') title: any;
    containersDataSource;

    ngOnInit(): void {
        // console.log(this.data.containersList);
        // this.containersDataSource = new MatTableDataSource(this.data.containersList);
        const oneDay = 24 * 60 * 60 * 1000;
        this.containersList.subscribe((item: any) => {
            item.container_charges.map((container: any) => {
                if (container.from_date != null && container.to_date != null) {
                    const fromDate: any = new Date(container.from_date);
                    const endDate = new Date(container.to_date);
                    endDate.setSeconds(endDate.getSeconds() - 1);
                    const newEndDate = new Date(fromDate) > new Date(endDate) ? fromDate : endDate;
                    const toDate: any = new Date(newEndDate);
                    container.to_date = toDate;
                    const chargableTime = toDate.getTime() - fromDate.getTime();
                    const chargableDays = Math.round(Math.abs(chargableTime / oneDay));
                    container.chargable_days = chargableDays < 0 ? 0 : chargableDays;
                    container.per_day = container.chargable_days != 0 ? Number(Number(container.total_amount) / Number(container.chargable_days)).toFixed(2) : 0;
                } else {
                    container.chargable_days = 0;
                    container.per_day = 0;
                }
                container.currency = item.currency;
            });
            this.containersDataSource = new MatTableDataSource(item.container_charges);
        })
    }
}
